/**
 * API Documentation
 * API Documentation
 *
 * The version of the OpenAPI document: uk-cca-app-api 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface EnergyOrCarbonSavingActionsAndMeasuresImplementedItem {
  facilityId?: string;
  actionCategoryType:
    | 'ENERGY_MANAGEMENT'
    | 'PROCESS_OPTIMISATION'
    | 'NEW_TECHNOLOGY_UPTAKE'
    | 'INSULATION_IMPROVEMENT'
    | 'INFRASTRUCTURE_IMPROVEMENT'
    | 'SWITCHING_NON_RENEWABLE_FUELS'
    | 'HEAT_RECOVERY'
    | 'SWITCHING_TO_CHP'
    | 'SWITCHING_TO_BIOMASS_HEATING'
    | 'SWITCHING_TO_RENEWABLE_POWER'
    | 'OTHER_CONTRIBUTIONS';
  savingActionsImplemented: string;
  reasonsForImplementation: string;
  implementationDate: string;
  fixedEnergyConsumptionOrCarbonEmissionsImpacted: 'FIXED' | 'VARIABLE' | 'FIXED_AND_VARIABLE';
  energyConsumptionOrCarbonEmissionsImpactedPercentage: string;
  expectedExtentOfChangeImplementedPercentage: string;
  expectedSavingsFromTheChangeImplementedPercentage: string;
  estimatedChangeInEnergyConsumptionPercentage: string;
  estimatedChangeInCarbonEmissionsPercentage: string;
  notes?: string;
}
